import { Injectable } from "@angular/core";

// bfx
import { SystemConfigPromiseService } from "shared/cubiq-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
/* RBAC - Role Based Access Service */
export class BfxRBACService {
  /**********************************************************************/
  /* DATA */
  private primed: boolean = false;
  private primePromise: Promise<boolean>;
  private rolesMap: Map<string, string> = new Map<string, string>();

  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(private systemConfigService: SystemConfigPromiseService) {
    this.initializeRoles();
  }

  /**********************************************************************/
  /* INITIALIZATION */

  private initializeRoles(): void {
    this.primePromise = new Promise<boolean>((resolve, reject) => {
      if (this.primed) {
        resolve(true);
      } else {
        this.systemConfigService.getAllRoles().then(
          (roles: Map<string, string>) => {
            this.rolesMap = roles;
            this.primed = true;
            resolve(true);
          },
          (rjc) => {
            reject(rjc);
          },
        );
      }
    });
  }

  /**********************************************************************/
  /* PUBLIC METHODS */

  public hasRole(role: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.primePromise.then(
        (value: boolean) => {
          if (value) {
            let result = this.rolesMap.has(role);
            resolve(result);
          } else {
            resolve(false);
          }
        },
        (rjc) => {
          resolve(false);
        },
      );
    });
  }
}
